var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9672 4.41595C14.6872 5.18395 15.1192 6.23995 15.1192 7.34395C15.0712 9.69595 13.1512 11.616 10.7992 11.568C10.3192 11.568 9.83923 11.472 9.40723 11.328C10.1752 12.192 11.2792 12.72 12.5272 12.72C14.8792 12.768 16.8472 10.848 16.8472 8.49595C16.8472 6.62396 15.6472 5.03995 13.9672 4.41595Z",
    fill: "#57B757",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9516 12.432H11.9036C10.7036 12.432 9.5516 11.952 8.6876 11.04C7.8236 10.128 7.3916 9.02398 7.3916 7.77598C7.4396 5.27998 9.4556 3.26398 11.9516 3.26398H11.9996C14.4956 3.31198 16.5596 5.37598 16.5116 7.87198C16.5116 10.416 14.4476 12.432 11.9516 12.432ZM11.9516 3.88798C9.7916 3.88798 7.9676 5.66398 7.9676 7.82398C7.9676 8.87998 8.3516 9.88798 9.1196 10.656C9.8876 11.424 10.8476 11.856 11.9516 11.856H11.9996C14.1596 11.856 15.9836 10.08 15.9836 7.91998C15.9836 5.71198 14.2076 3.88798 11.9516 3.88798C11.9996 3.88798 11.9996 3.88798 11.9516 3.88798Z",
    fill: "#57B757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0952 19.488C18.1432 17.184 16.7032 15.168 14.6872 14.304C15.7432 15.312 16.4152 16.752 16.3672 18.336V19.728H8.15918V20.88H18.0952V19.488Z",
    fill: "#57B757",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2316 20.304V18.912C17.2316 17.52 16.7036 16.176 15.7436 15.168C14.7356 14.16 13.4396 13.584 12.0476 13.584H11.9996C10.6076 13.584 9.31155 14.112 8.30355 15.072C7.29555 16.08 6.71955 17.376 6.71955 18.768V20.256H6.14355V18.72C6.14355 17.136 6.76755 15.696 7.91955 14.592C9.02355 13.488 10.5116 12.912 12.0476 12.912C13.6316 12.912 15.0716 13.536 16.1756 14.688C17.2796 15.84 17.8556 17.28 17.8556 18.816V20.208H17.2316V20.304Z",
    fill: "#57B757"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1272 18.288H8.15918V18.864H10.1272V18.288Z",
    fill: "#57B757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2391 15.36H11.6631V20.304H12.2391V15.36Z",
    fill: "#57B757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManager);
export default __webpack_public_path__ + "static/media/manager.0409256b58157bfc0ccc041aad3a9ed0.svg";
export { ForwardRef as ReactComponent };